// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\EmailActionResponse

import { BookingEventActionType } from './enums.gen';

export type EmailActionApiResponse = {
	type: BookingEventActionType.Email;
	subject: string;
	message: string;
};

export type EmailAction = {
	type: BookingEventActionType.Email;
	subject: string;
	message: string;
};

export function hydrateEmailAction(data: EmailActionApiResponse): EmailAction {
	return { ...data };
}